import Vue from 'vue';

export default {
    async getClientBalanceReports(clientId) {
        return (await Vue.http.get(`/api/curacao/balancereports/byclient/${clientId}`)).data;
    },
    async getBalanceReport(reportId) {
        return (await Vue.http.get(`/api/curacao/balancereports/get/${reportId}`)).data;
    },
    async decrypt(formData, password, salt) {
        return (await Vue.http({
          method: 'post',
          url: `/api/curacao/decrypt/${password}/${salt}`,
          data: formData,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })).data;
    }
}


// WEBPACK FOOTER //
// ./src/services/curacao.service.js